/**
 * JavaScript developed and modified by Souleymane Dembele on 1/22/2020
 */

// Will need to install isomorphic fetch to for stability
import "isomorphic-fetch";
// import { getSessionToken } from "./getToken";

// const testToken =
//   "eyJraWQiOiJETjcwXC9NNkNveHZFc2E1UTZqMk1tQmUyNVU1N3Y5RkF2ZTI0Q2hURjlMND0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI2ZmZjNjI2OS1lMmRjLTQ0MjEtOGFiNC1iNGYyNmFlNjYxZmUiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImN1c3RvbTpwcml2YWN5X3BvbGljeSI6InllcyIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX3pCaXdPT0J3aiIsImNvZ25pdG86dXNlcm5hbWUiOiJzb3VsZXltYW5lMSIsImN1c3RvbTplbWFpbF9vcHRfaW4iOiJ5ZXMiLCJvcmlnaW5fanRpIjoiNGViZDQ0YzAtMzEzNi00ZGFlLWIzOTItMWM5MzRiYWFkNmEzIiwiYXVkIjoiM2s2Z25jOXNkNmFuNGsyMnJhaGc0Zms5a2MiLCJldmVudF9pZCI6ImVjMjdlMmEyLTE2ZmItNDA2My04NTM5LTcyODRkMmYwMTE2MCIsImN1c3RvbTp0ZXJtc19vZl91c2UiOiJ5ZXMiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTY2MDg1MDg0NSwibmFtZSI6InNvdWxleW1hbmUxIiwiZXhwIjoxNjYyNTI2MzgxLCJpYXQiOjE2NjI0Mzk5ODEsImp0aSI6IjFlNjNjMzcwLTk0NGMtNDJlMC1iYzQ1LWRlYzQ1NWYyZjU2MSIsImVtYWlsIjoic291bGV5bWFuZS5kZW1iZWxlQGZsdWtlLmNvbSJ9.g_zfZAt_RcSnrite7ux9cLvAoiBEuWs5UtW6YzDxPEvW5QQmQHSAopWCHFDBAeFn6yfIFgGlrKrx45ROl7_3liyUPToKexcCzpT6EZC2Rjc4LmviUt06IqY-G_Er5Vr4A-AJeUtO0pYNCx9zwrbf12qnjhX8XGYdos08u_jhibsG8xRNpZII75HciM14i4SXd2a3p4besdigGXa7X7p08rqHV3PjkwrJS7PHBna3JE7F5SW5L-xMKFu4ZrI94g_YGKnTIySHIIBC0JYkdeyc88B2tlbjOGvzRfog3CNTDAxcDOH9tZgpJijUrldXrZKzeIsVKl6X-fSp2LfHaVRRMA";

// simple utile to make fetch
function makeFetch(url, info) {
  return fetch(url, info);
}

async function json(url, method = "GET", payload = {}) {
  // const jwtToken = await getSessionToken();
  let data = {
    method,
    mode: "cors",
    body: JSON.stringify(payload),
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  };

  if (method === "GET") {
    delete data.body;
  }

  let response = await makeFetch(url, data);

  if (response.ok) {
    let contentType = response.headers.get("Content-Type");

    if (contentType?.indexOf("application/json") > -1) {
      return response.json();
    }

    return response.statusText;
  }
  throw response;
}

// Post and Get method using
function get(url) {
  return json(url);
}

function post(url, payload) {
  return json(url, "POST", payload);
}

function put(url, payload) {
  return json(url, "PUT", payload);
}

function destroy(url, payload) {
  return json(url, "DELETE", payload);
}

function reader(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });
}

export { get, post, put, destroy, makeFetch, reader };
